<template>
  <div class="uk-grid uk-grid-small" data-uk-grid>
    <div class="uk-width-1-1">
      <button href="#" class="uk-button uk-width-1-1 uk-button-primary" @click.prevent="onClick">
        <span v-if="knumber === 'K10111'">Farbauswahl-Verfügbarkeit hier klicken</span>
        <span v-else>Farbauswahl - Verfügbarkeit</span>
        <!--<span uk-icon="arrow-right" v-if="!showList"></span>
        <span uk-icon="arrow-down" v-if="showList"></span>-->
      </button>
    </div>
    <div ref="modal" class="uk-flex-top uk-modal-container" data-uk-modal>
      <div class="uk-modal-dialog uk-margin-auto-vertical" data-uk-overflow-auto>
        <button class="uk-modal-close-default" type="button" uk-close></button>
          <div class="uk-modal-header">
              <h2 class="uk-modal-title">
                {{ vehicle }}
                <div class="uk-text-small">{{ edition }} (Konfig-Nr.: {{ carId }})</div>
              </h2>
          </div>
          <div class="uk-modal-body">
          <div class="uk-overflow-auto">
            <div uk-spinner v-if="waiting"></div>
            <transition name="fade">
              <div>
                <div v-if="!waiting">
                <p class="uk-hidden@m uk-text-bold">Preis auf Anfrage</p>
                <table class="uk-table uk-table-small uk-text-small uk-table-divider">
                  <thead>
                    <tr>
                      <th class="uk-table-shrink uk-visible@m">Fahrzeug Nr.</th>
                      <th class="uk-table-shrink uk-visible@m">Hersteller / Modell</th>
                      <th class="uk-table-shrink uk-visible@m">Motor</th>
                      <th class="uk-table-shrink uk-visible@m">KW/PS</th>
                      <th class="uk-table-shrink">Farbe</th>
                      <th class="uk-table-shrink uk-visible@m">KM</th>
                      <th class="uk-table-shrink">Lieferzeit</th>
                      <th class="uk-table-shrink uk-visible@m">Preis</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="vehicle in vehicles" :key="vehicle.id">
                      <td class="uk-preserve-width uk-visible@m">{{ vehicle.carId }}</td>
                      <td class="uk-preserve-width uk-visible@m">{{ vehicle.make }} {{ vehicle.model }}</td>
                      <td class="uk-preserve-width uk-visible@m">{{ vehicle.modelEngine }}</td>
                      <td class="uk-preserve-width uk-visible@m">{{ vehicle.powerkw }} / {{ vehicle.powerps }}</td>
                      <td class="uk-preserve-width">{{ vehicle.color }}</td>
                      <td class="uk-preserve-width uk-visible@m">{{ vehicle.truemileage }}</td>
                      <td class="uk-preserve-width">{{ vehicle.deliverydate }}</td>
                      <td class="uk-preserve-width uk-visible@m">auf Anfrage</td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    modelKey: {
      type: String,
      required: true
    },
    vehicle: {
      required: true
    },
    edition: {
      required: true
    },
    carId: {
      type: String,
      required: false
    },
    knumber: {
      required: false,
    },
  },
  data() {
    return {
      vehicles: [],
      showList: false,
      waiting: false
    }
  },
  methods: {
    getModels() {
      this.waiting = true;
      axios.get('/wp-json/ansolution/v1/webkfz/shop-models', {params: {modelKey: this.modelKey}}).then(response => {
        this.vehicles = response.data.vehicles;
        this.waiting = false;
      });
    },
    onClick() {
      //if(!this.showList) {
        this.getModels()
        UIkit.modal(this.$refs.modal).show();
      //}
      //this.showList = !this.showList
    }
  }
}
</script>
